import _ from 'underscore';
import Components from 'components';
import ComponentBase from 'components/_base/ComponentBase';
import Utils from 'helpers/Utils';
import jQuery from 'jquery';

export default ComponentBase.extend(
  /**
   * @lends core.components.MainMenu
   */
  {

    template: require('./mainMenu.hbs'),

    /**
     * Create a mainMenu instance.
     * @class MainMenu
     * @classdesc This is the main component on which the menu will be built. 
     * @memberof core.components
     * @extends ComponentBase
     * @constructs
     * @param {Object} options - The config provided by json
     */
    constructor(options) {
      this.components = {};
      this.lastElementIn = {};
      this.classPrefix = options.classPrefix || '.lmm-main-menu-';
      this.visible = options.visible ? true : false;
      ComponentBase.prototype.constructor.call(this, options);
    },

    /**
     * Initialize the component 
     * @function
     * @param {Object} options - The config provided by json
     * @listens  Widget#SELECTED_TOOL
     */
    initialize(options) {
      ComponentBase.prototype.initialize.call(this, options);
      this.initPanel();
      this.listenTo(this.bus, 'TOGGLE_MAIN_MENU', this.togglePanel);
      this.listenTo(this.bus, 'SELECTED_TOOL', this.selectTool);
      let components = options.properties.components;
      if (_.isObject(options.properties.components.Categories)) {
        components = _.extend(components,
          options.properties.components.Categories);
      }

      if (_.isObject(components)) {
        this._createSubComponents(components);
        this._activateComponents(options.properties);
      }
      //BUG IE-11
      let _this = this;
      this._bugIE11MaxHeight(this);
      jQuery(window).resize(function() {
        _this._bugIE11MaxHeight(_this);
      });
    },

    // Deactivates any default events of ComponentBase Class
    events: {},

    _activateComponents(properties) {
      if (_.isObject(properties)) {
        if (!_.isEmpty(properties.defaultActive)) {
          let defaultActive = _.isString(properties.defaultActive) ? [properties.defaultActive] : properties.defaultActive;
          defaultActive.forEach((element) => {
            this.components[element].activate();
          });
        }
        if (_.isString(properties.defaultSelected)) {
          let defaultSelected = properties.defaultSelected;
          if (_.isObject(this.components[defaultSelected])) {
            this.components[defaultSelected].select();
          }
        }
      }
    },

    _createSubComponents(components) {
      let availableComponents = _.filter(components, (component, key) => {
        if (component) {
          component.identifier = key;
          return true;
        } else {
          return false;
        }
      });

      let sortedComponens = _.sortBy(availableComponents, 'order');
      _.each(sortedComponens, (component) => {
        if (_.isObject(Components[component.componentConstructorClass])) {
          let _component = this.components[component.identifier] = new Components[component.componentConstructorClass]
            (
              _.extend({}, component, {
                map: this.map,
                widget: this.widget,
                isChild: true,
                properties: component.properties || {}
              }));
          this.append(_component.el, _component.position);
        }
      });
    },
    /**
     * Initialize the visibility of the panel
     * @function
     */
    initPanel() {
      if (!this.visible) {
        this.hide();
      }
    },
    /**
     * Toggle the visibility of the panel  
     */
    togglePanel() {
      if (this.visible) {
        this.hide();
      } else {
        this.show();
      }
      this.visible = !this.visible;
    },
    /**
     * Select a specified component of MainMenu
     * @function 
     * @param {object} myObj
     * @param {string} myObj.identifier - Indicates the id of the tool to select
     * @param {object} myObj.subView- The subview of the component
     * @param {ComposedComponentBase} myObj.instanceObj - The instance of component
     */
    selectTool(eventData) {
      let sender = eventData.objInstance;
      let subView = eventData.subView;
      if (this._isOwnCompontent(sender)) {
        let container = sender.childPosition || 'container';
        if (_.isObject(subView)) {
          if (this.lastElementIn[container] !== subView.el) {
            this.append(subView.el, container);
            this.lastElementIn[container] = subView.el;
          }
        }

        _.each(this.components, (component, identifier) => {
          if (identifier !== eventData.identifier && component.childPosition === container && component.selectable &&
            component.isActivated) {
            component.unSelect();
          }
        });
      }
    },

    /**
     * Append an element into the Main Menu container
     * @param {object} element - The jQuery element to append
     * @param {string} container - The jQuery selector of container
     */
    append(element, container) {
      this.$el.find(this.classPrefix + container).append(element);
    },

    _isOwnCompontent(component) {
      let found = _.find(this.components,
        (_component) => {
          return _component === component;
        });
      return component === found;
    },

    _bugIE11MaxHeight(_this) {
      let name = Utils.getBrowser().name;
      if (name === 'IE' || name === 'Edge') {
        let height = (_this.widget.$el.find('.lmm-maps-widget-container').height() - 125) + 'px';
        _this.$el.find('.main-menu-container').css('max-height', height);
        _this.$el.find('.main-menu-fluid-container').css('max-height', height);
        _this.$el.find('.main-menu-fluid-panel').css('max-height', height);
      }
    }
  });



// WEBPACK FOOTER //
// ./lmm-widget/src/components/mainMenu/MainMenu.js